/** Display formatting for the policy record (OR-1665). */

/** ISO "2025-11-11" → "11/11/2025"; null → "-". */
export function formatDate(iso: string | null): string {
    if (!iso) return "-";
    const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})/);
    return m ? `${m[2]}/${m[3]}/${m[1]}` : iso;
}

/** Term strip label: effective 2025 → expiration 2026 reads "PY 25-26". */
export function policyYearLabel(effectiveDate: string, expirationDate: string): string {
    const yy = (iso: string) => iso.slice(2, 4);
    return `PY ${yy(effectiveDate)}-${yy(expirationDate)}`;
}

const FULL_USD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 });
const COMPACT_USD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", notation: "compact", minimumFractionDigits: 0, maximumFractionDigits: 1 });

function toNumber(value: string | null): number | null {
    if (value === null || value === "") return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
}

/** "$1,158,628" — the summary's premium in force. */
export function moneyFull(value: string | null): string {
    const n = toNumber(value);
    return n === null ? "-" : FULL_USD.format(n);
}

/** "$310K", "$1.2M" — limits, retention, SIR and table premiums. */
export function moneyCompact(value: string | null): string {
    const n = toNumber(value);
    return n === null ? "-" : COMPACT_USD.format(n);
}

/** "$1M / $3M" — per claim / aggregate. */
export function limitPair(perClaim: string | null, aggregate: string | null): string {
    if (toNumber(perClaim) === null && toNumber(aggregate) === null) return "-";
    return `${moneyCompact(perClaim)} / ${moneyCompact(aggregate)}`;
}
